/** Cuántas cuentas trae una página. Fijo: la vista no negocia el tamaño. */
export const ADMIN_PAGE_SIZE = 25;
/**
 * Por qué se filtra la lista.
 *
 * `borradas` es el único que enseña cuentas con `deleted_at`: en los demás no salen,
 * igual que en todo el resto del juego. Verlas es lo que permite restaurar una.
 */
export const ADMIN_FILTERS = ["todas", "admin", "dev", "presidentes", "borradas"];
export function isAdminFilter(value) {
    return typeof value === "string" && ADMIN_FILTERS.includes(value);
}
//# sourceMappingURL=admin.js.map